import React, { useEffect, useMemo, useState } from "react";
import styled, { keyframes } from "styled-components";

const AssistantLoader = () => {
  const sentences = useMemo(
    () => [
      "C’est parti nous recherchons les meilleures propositions…",
      "ça y est : déjà les premiers éléments",
      "Voici les propositions pour votre choix…",
    ],
    []
  );
  const [sentenceIndex, setSentenceIndex] = useState(0);

  useEffect(() => {
    const timeout = setInterval(() => {
      setSentenceIndex((prevState) =>
        prevState < sentences.length - 1 ? prevState + 1 : prevState
      );
    }, 5000);
    return () => clearInterval(timeout);
  }, [sentences.length]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h1
          style={{
            fontSize: 30,
            color: "#576e81",
          }}
        >
          ENJOY COACH
        </h1>
        <h2
          style={{
            fontWeight: "normal",
            fontSize: 18,
            color: "var(--color-blue)",
          }}
        >
          {sentences[sentenceIndex]}
        </h2>
      </div>
      <LoaderDiv>
        <LoaderOverlayDiv />
        <LoaderCogsDiv>
          <LoaderCogTopsDiv>
            <TopPartDiv />
            <TopPartDiv />
            <TopPartDiv />
            <TopHoleDiv />
          </LoaderCogTopsDiv>
          <LoaderCogLeftDiv>
            <LeftPartDiv />
            <LeftPartDiv />
            <LeftPartDiv />
            <LeftHoleDiv />
          </LoaderCogLeftDiv>
          <LoaderCogBottomDiv>
            <BottomPartDiv />
            <BottomPartDiv />
            <BottomPartDiv />
            <BottomHoleDiv />
          </LoaderCogBottomDiv>
        </LoaderCogsDiv>
      </LoaderDiv>
    </div>
  );
};

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const rotate_left = keyframes`
 from {
    transform: rotate(16deg);
  }
  to {
    transform: rotate(376deg);
  }
`;

const rotate_right = keyframes`
  from {
    transform: rotate(4deg);
  }
  to {
    transform: rotate(364deg);
  }
`;

const LoaderDiv = styled.div`
  height: 280px;
  position: relative;
  margin: auto;
    @media screen and (min-width: 1000px){
        height: 280px;
        width: 500px;        
    }
`;

const LoaderOverlayDiv = styled.div`
  width: 150px;
  height: 150px;
  background: transparent;
  box-shadow: 0px 0px 0px 1000px rgba(255, 255, 255, 0.67),
    0px 0px 19px 0px rgba(0, 0, 0, 0.16) inset;
  border-radius: 100%;
  z-index: -1;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

const LoaderCogsDiv = styled.div`
  z-index: -2;
  width: 100px;
  height: 100px;
  top: -120px !important;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

const LoaderCogTopsDiv = styled.div`
  position: relative;
  width: 100px;
  height: 100px;
  transform-origin: 50px 50px;
  animation: ${rotate} 10s infinite linear;
  div:nth-of-type(1) {
    transform: rotate(30deg);
  }
  div:nth-of-type(2) {
    transform: rotate(60deg);
  }
  div:nth-of-type(3) {
    transform: rotate(90deg);
  }
`;

const TopPartDiv = styled.div`
  width: 100px;
  border-radius: 10px;
  position: absolute;
  height: 100px;
  background: var(--color-purple);
`;

const TopHoleDiv = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 100%;
  background: white;
  position: absolute;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

const LoaderCogLeftDiv = styled.div`
  position: relative;
  width: 80px;
  transform: rotate(16deg);
  top: 28px;
  transform-origin: 40px 40px;
  animation: ${rotate_left} 10s 0.1s infinite reverse linear;
  left: -24px;
  height: 80px;
  div:nth-of-type(1) {
    transform: rotate(30deg);
  }
  div:nth-of-type(2) {
    transform: rotate(60deg);
  }
  div:nth-of-type(3) {
    transform: rotate(90deg);
  }
`;

const LeftPartDiv = styled.div`
  width: 80px;
  border-radius: 6px;
  position: absolute;
  height: 80px;
  background: var(--color-green);
`;

const LeftHoleDiv = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: white;
  position: absolute;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

const LoaderCogBottomDiv = styled.div`
  position: relative;
  width: 60px;
  top: -65px;
  transform-origin: 30px 30px;
  animation: ${rotate_right} 10.2s 0.4s infinite linear;
  transform: rotate(4deg);
  left: 79px;
  height: 60px;
  div:nth-of-type(1) {
    transform: rotate(30deg);
  }
  div:nth-of-type(2) {
    transform: rotate(60deg);
  }
  div:nth-of-type(3) {
    transform: rotate(90deg);
  }
`;

const BottomPartDiv = styled.div`
  width: 60px;
  border-radius: 5px;
  position: absolute;
  height: 60px;
  background: var(--color-yellow);
`;

const BottomHoleDiv = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background: white;
  position: absolute;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
`;

export default AssistantLoader;
